import { BenefitsCardProps } from "@/app/interface/components"
import React from "react"
import styles from "@/styles/BenefitsCard.module.scss"

const BenefitsCard: React.FC<BenefitsCardProps> = ({ img, number, text, width }) => {
    return (
        <div className={styles.main} style={{width: width}}>
            <div className={styles.content}>
                <div>
                    <h3 className="h2-bold">{number}</h3>
                </div>
                <p>{text}</p>
            </div>
            <img src={img} alt="" loading="lazy" width={width} height={360} />
        </div>
    )
}

export default React.memo(BenefitsCard)
